export type Config = {
  ENV: string;
  api: string;
  qasAuthToken: string;
  analytics: boolean;
};

export function getConfig(): Config {
  let foundConfig: any = {};
  if (TAL || TAL.config) {
    foundConfig = TAL.config;
  }

  if (!foundConfig.qasAuthToken) {
    throw new Error('Cannot find config qasAuthToken');
  }

  if (!foundConfig.api) {
    throw new Error('Cannot find config api');
  }

  return {
    ENV: foundConfig.ENV ? foundConfig.ENV : 'local',
    api: foundConfig.api,
    qasAuthToken: foundConfig.qasAuthToken,
    analytics: foundConfig.analytics ? foundConfig.analytics : false
  };
}

export const config: Config = getConfig();
